import tiffinLogo from "../../images/TIFFIN_logo_blue.png"
import { holidaysByFsp } from "./holidays"
import { timeRules } from "./time-rules/tiffin/time-rules"

import tiffinFavSvg from "/tiffin-fav/tiffin_favicon.svg?url"
import tiffinFavIco32 from "/tiffin-fav/tiffin_favicon_19x32.ico"
import tiffinFavAppleTouch from "/tiffin-fav/tiffin_favicon_apple_108x180.png"
import { getClientEnv } from "./client-env-init"

export const tiffinFAQs = {
  general: {
    id: "general",
    header: "faq.general",
    svg: "test",
    content: [
      {
        question: "faq.general1",
        answer: "faq.generalanswer1",
      },
      {
        question: "faq.general2",
        answer: "faq.generalanswer2",
      },
      {
        question: "faq.general3",
        answer: "faq.generalanswer3",
      },
      {
        question: "faq.general4",
        answer: "faq.generalanswer4",
      },
      {
        question: "faq.general5",
        answer: "faq.generalanswer5",
      },
      {
        question: "faq.general6",
        answer: "faq.generalanswer6",
      },
      {
        question: "faq.general7",
        answer: "faq.generalanswer7",
      },
      {
        question: "faq.general8",
        answer: "faq.generalanswer8",
      },
      {
        question: "faq.general9",
        answer: "faq.generalanswer9",
      },
      {
        question: "faq.general10",
        answer: "faq.generalanswer10",
      },
      {
        question: "faq.general11",
        answer: "faq.generalanswer11",
      },
      {
        question: "faq.general12",
        answer: "faq.generalanswer12",
      },
      {
        question: "faq.general13",
        answer: "faq.generalanswer13",
      },
      {
        question: "faq.general14",
        answer: "faq.generalanswer14",
      },
    ],
  },
}

export const tiffinConfig = {
  fspId: "tiffin",
  fspName: "Tiffin",
  timeZone: "Europe/Copenhagen",
  ns: "tiffin",
  url: "https://tiffin.dk",
  faqs: tiffinFAQs,
  namespace: "tiffin",
  colorTheme: "tiffin",
  // The Radix color that has been overwritten by the Tiffin primary blue color
  pColor: "sky",
  cognito: {
    userPoolId: getClientEnv().VITE_AWS_TIFFIN_USER_POOL_ID,
    userPoolWebClientId: getClientEnv().VITE_AWS_TIFFIN_USER_POOL_WEB_CLIENT_ID,
  },
  fathomAnalytics: {
    siteId: "LNMYXIUE",
    includedDomains: ["www.kitchen.tiffin.dk", "kitchen.tiffin.dk", "localhost:4001"],
  },
  font: "Poppins",
  headingFont: "BDSupper",
  logo: {
    src: tiffinLogo,
    alt: "Tiffin logo",
  },
  favIcons: {
    ico32: tiffinFavIco32,
    svg: tiffinFavSvg,
    appleTouch: tiffinFavAppleTouch,
  },
  languages: [
    { code: "en-GB", label: "English" },
    { code: "da", label: "Dansk" },
  ],
  socials: {
    instagram: "https://www.instagram.com/tiffin.dk/",
    facebook: null,
    x: null,
    linkedin: "https://www.linkedin.com/company/tiffinlevering/",
    blog: null,
  },
  supportPhone: "53 52 40 45",
  supportEmail: "kitchens@tiffin.dk",
  // Tiffin has no Front Chat channel.
  frontChatId: null,
  appRevalidationIntervalMs: 5 * 60 * 1000,
  enablePeriodicRevalidation: true,
  enableRevalidateOnFocus: true,
  enableSecondaryMarket: true,
  showAllergens: true,
  pickupTimesByMealTime: {
    Lunch: {
      weekdays: "10:45",
      weekend: null,
    },
    Dinner: {
      weekdays: null,
      weekend: null,
    },
  },
  timeRules,
  holidaysMap: holidaysByFsp.tiffinYearlyHolidays,
} as const
